import React from 'react';

import AnalyticsBarChart from './AnalyticsBarChart';
import { createBarChartDataset } from 'helpers/analytics';

const UsersAnalytics = ({ usersAnalytics }) => {
  if (!usersAnalytics || !usersAnalytics.length) {
    return null;
  }

  const activeDataset = createBarChartDataset(
    usersAnalytics,
    'status',
    'active',
  );
  const inactiveDataset = createBarChartDataset(
    usersAnalytics,
    'status',
    'inactive',
  );

  return (
    <div style={{ display: 'flex' }}>
      <AnalyticsBarChart
        dataset={activeDataset}
        name="Active Users"
        fill="#0489A8"
      />
      <AnalyticsBarChart
        dataset={inactiveDataset}
        name="Inactive Users"
        fill="#74A9BB"
      />
    </div>
  );
};

export default UsersAnalytics;
